module.exports = __webpack_public_path__ + "static/media/ryan_bishop_serious.48a47864.png";